/**
 * Initialize Firebase Analytics using Firebase Analytics SDK Web version 8
 * (https://firebase.google.com/docs/analytics/get-started?platform=web#web-version-8)
 */
export default function generateAdapter() {
  let analytics;
  window.dataLayer = window.dataLayer || [];

  function appendDataLayer() {
    if (window.dataLayer) {
      window.dataLayer.push(arguments);
    }
  }

  return {
    /**
     * Initialize Firebase Analytics
     * @param {*} options
     * @param {string} options.firebaseApp - The instance of firebase.initializeApp(config)
     * @returns Instance of firebaseApp.analytics() function
     */
    initialize(options) {
      const { firebaseApp, config } = options || {};
      if (!firebaseApp) {
        console.warn('[firebase-adapter]', '{ firebaseApp: Object } is required in initialize()');
        return null;
      }
      
      /**
        * By default, we set page_view event to not automatically triggered
        * because most of our TMS are single page app
        * and page_view need to be manually triggered on each client side router changed
        * (https://github.com/firebase/firebase-js-sdk/issues/3988#issuecomment-716638644)
       */
      appendDataLayer('set', {
        send_page_view: false,
        ...config,
      });

      analytics = firebaseApp.analytics();
      return analytics;
    },

    /**
     * Get the instance of Firebase Analytics
     * @returns Instance of firebaseApp.analytics() function
     */
    getTrackerInstance() {
      return analytics;
    },

    /**
     * Track event
     * @param {string} eventName - The name of event
     * @param {object} properties - Event properties passed into logEvent()
     * @returns The result of logEvent()
     */
    trackEvent(eventName, properties) {
      if (!eventName) {
        console.warn('[firebase-adapter]', 'eventName is required in logEvent()');
        return null;
      }

      return analytics.logEvent(eventName, { ...properties });
    },
  };
}
